/* eslint-disable complexity */

/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import PinkDotsIllustration from '../../../assets/svg-components/speed/pink_dots.svg';
import IllustrationTriangles from '../../../assets/svg-components/speed/triangels.svg';
import LinesIllustration from '../../../assets/svg-components/speed/yellow_section_side_lines.svg';
import { SectionContent } from '../../../components/section/section-content';
import { SectionHero } from '../../../components/section/section-hero';
import { SectionTitle } from '../../../components/section/section-title';
import { Text } from '../../../components/text/text';
import { Title } from '../../../components/title/title';
import { Translate } from '../../../components/translate';
import { SpeedCardComponent } from './speed-card';
import './speed-section.scss';

interface Props {
  domain?: string;
  percent_increase?: number;
  score?: number;
}

const SpeedSection: React.FC<Props> = ({ domain, percent_increase, score }) => {
  return (
    <React.Fragment>
      <SectionHero className="rc-speed-section">
        <img
          className="rc-speed-section__heading-illustration"
          src="https://www.siteground.com/static/en/img/recap2023/02_BG.png"
          alt="speed section image"
        />

        <SectionTitle className="rc-speed-section__title">
          {domain ? (
            <Translate id="translate.speed.section.personal.title" values={{ website: domain }} />
          ) : (
            <Translate id="translate.speed.section.title" />
          )}
        </SectionTitle>
        <LinesIllustration className="rc-speed-section__lines-illustration-first" />
      </SectionHero>
      <SectionContent className="rc-speed-section">
        {domain ? (
          <React.Fragment>
            <SpeedCardComponent
              title={
                score ? (
                  <Translate id="translate.speed.card.peak.personal.title" values={{ performance: score }} />
                ) : (
                  <Translate id="translate.speed.card.peak.title" />
                )
              }
              content={
                score ? (
                  <Translate id="translate.speed.card.peak.personal.text" values={{ performance: score }} />
                ) : (
                  <Translate id="translate.speed.card.peak.text" />
                )
              }
              circularProgressValue={score || 70}
              circularProgressValueSuffix="%"
              animationName="speed-card-peak-performance"
              afterContent={<IllustrationTriangles className="rc-speed-section_card-location-illustration" />}
              className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-0"
            />
            <SpeedCardComponent
              title={
                percent_increase ? (
                  <Translate
                    id="translate.speed.card.moving.personal.title"
                    values={{ percentage: percent_increase }}
                  />
                ) : (
                  <Translate id="translate.speed.card.moving.title" />
                )
              }
              content={
                percent_increase ? (
                  <Translate id="translate.speed.card.moving.personal.text" values={{ percentage: percent_increase }} />
                ) : (
                  <Translate id="translate.speed.card.moving.text" />
                )
              }
              circularProgressValue={percent_increase || 85}
              circularProgressValueSuffix="%"
              animationName="speed-card-faster"
              className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-1"
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SpeedCardComponent
              title={
                percent_increase ? (
                  <Translate
                    id="translate.speed.card.moving.personal.title"
                    values={{ percentage: percent_increase }}
                  />
                ) : (
                  <Translate id="translate.speed.card.moving.title" />
                )
              }
              content={
                percent_increase ? (
                  <Translate id="translate.speed.card.moving.personal.text" values={{ percentage: percent_increase }} />
                ) : (
                  <Translate id="translate.speed.card.moving.text" />
                )
              }
              circularProgressValue={percent_increase || 85}
              circularProgressValueSuffix="%"
              animationName="speed-card-faster"
              className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-0"
            />
            <SpeedCardComponent
              title={
                score ? (
                  <Translate id="translate.speed.card.peak.personal.title" values={{ performance: score }} />
                ) : (
                  <Translate id="translate.speed.card.peak.title" />
                )
              }
              content={
                score ? (
                  <Translate id="translate.speed.card.peak.personal.text" values={{ performance: score }} />
                ) : (
                  <Translate id="translate.speed.card.peak.text" />
                )
              }
              circularProgressValue={score || 70}
              circularProgressValueSuffix="%"
              animationName="speed-card-peak-performance"
              afterContent={<IllustrationTriangles className="rc-speed-section_card-location-illustration" />}
              className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-1"
            />
          </React.Fragment>
        )}
        <SpeedCardComponent
          title={<Translate id="translate.speed.card.data.center.title" />}
          content={<Translate id="translate.speed.card.data.center.text" />}
          circularProgressValue={11}
          enableAnimation={false}
          animationName="speed-card-datacenters"
          className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-2"
        />
        <SpeedCardComponent
          title={<Translate id="translate.speed.card.location.title" />}
          content={<Translate id="translate.speed.card.location.text" />}
          circularProgressValue={204}
          enableAnimation={false}
          animationSpeed={10}
          animationName="speed-card-locations"
          className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-3"
        />
        <SpeedCardComponent
          title={<Translate id="translate.speed.card.php.title" />}
          content={<Translate id="translate.speed.card.php.text" />}
          enableAnimation={false}
          animationName="speed-card-php"
          afterContent={<PinkDotsIllustration className="rc-speed-section__pink-dots-illustration" />}
          icon={
            <div className="rc-speed-section__php-icon-container">
              <Title className="rc-speed-section__php-icon-title" level="3" weight="bold">
                PHP<br></br>8.3
              </Title>
              <div className="rc-speed-section__php-icon-inner-container">
                <Text weight="bold" size="large" align="center">
                  <span className="rc-speed-section__php-icon-text-span">
                    <Translate id="translate.speed.card.php.beta" />
                  </span>
                </Text>
              </div>
            </div>
          }
          className="rc-rounded-card-wrapper rc-rounded-card-wrapper--background-color-4"
        />
        <LinesIllustration className="rc-speed-section__lines-illustration-second" />
        <LinesIllustration className="rc-speed-section__lines-illustration-third" />
      </SectionContent>
    </React.Fragment>
  );
};

export default SpeedSection;
